import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import SubscriptionPlan from 'components/SubscriptionPlan';
import { useGetSubscriptionsListQuery } from 'services';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'utils/sanitizeHtml';

const Subscriptions: React.FC = () => {
	const { translate } = useTranslate();
	const { data: planList = [] } = useGetSubscriptionsListQuery('recurring');

	return (
		<div className="subscriptions py-80">
			<Container fluid>
				<div className="subscriptions-heading text-center">
					<h2>
						<span>{translate('Common.flexible')}</span> {translate('Header.plans')}!
					</h2>
					<p className="mb-0">{parse(sanitizeHtml(translate('Plan.planPageDescription')))}</p>
				</div>

				<div className="subscriptions-plans d-flex flex-wrap">
					{planList?.length > 0 &&
						planList?.map((plan: any, index: number) => (
							<SubscriptionPlan plan={plan} key={index} />
						))}
				</div>
			</Container>
		</div>
	);
};

export default Subscriptions;
